module.exports = __webpack_public_path__ + "media/images/cplook/safari-pinned-tab-3018bebb59695e5f86ce90fd1c29bd46.svg";